<template>
    <div>
        <Card back>
            <template v-slot:header>
                <div>
                    <h4 class="d-inline">انواع شغل</h4>
                </div>
            </template>
            <template v-slot:content>
                <div v-if="showRow">
                    <h4 class="mt-3" @click="changeState(1)">
                        <i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i>
                    </h4>
                    <div>
                        <BnpGrid Selectable :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true"
                            :action="true" v-if="render">
                            <template slot="action-slot" slot-scope="props">
                                <div class="row text-center justify-content-center">
                                    <div class="text-center mx-3">
                                        <a href="javascript:;" @click="remove(props.props)">
                                            <h6><span class="fa fa-times hover-danger"></span></h6>
                                        </a>
                                    </div>
                                    <div class="text-center mx-3">
                                        <a href="javascript:;" @click="edit(props.props)">
                                            <h6><span class="fa fa-pencil-square-o hover-info hover-info"></span></h6>
                                        </a>
                                    </div>
                                    <div class="text-center mx-3">
                                        <a href="javascript:;" @click="detial(props.props)">
                                            <h6><span class="fas fa-info text-info hover-danger"></span></h6>
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </BnpGrid>
                    </div>
                </div>

                <div v-if="addRow">
                    <div>
                        <h4 class="mt-3" @click="changeState(0)">
                            <i class="fas fa-times text-danger"></i>
                        </h4>
                        <div class="row" id="addJobs">

                            <div class="col-12 col-md-4 text-right mt-3 mb-3">
                                <small id="LblJobCode"> کد شغل</small>
                                <input class="form-control text-left required" type="text"
                                    @keypress="$ValidNumber($event, 10)" id="JobCode" v-model="DataAxios.JobCode" />
                            </div>
                            <div class="col-12 col-md-4 text-right mt-3 mb-3">
                                <small id="LblJobName"> نام شغل</small>
                                <input class="form-control text-right required" type="text" id="JobName"
                                    v-model="DataAxios.JobName" />
                            </div>
                            <div class="col-12 col-md-3 text-right mt-3 mb-3">
                                <small id="LblPishFarz">پیش فرض</small>
                                <span class="form-control p-1">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input InputText"
                                            @click="statusChk($event)" :checked="DataAxios.PishFarz"
                                            v-model="DataAxios.PishFarz" id="DefaultHoze" />
                                        <label class="custom-control-label" for="DefaultHoze">پیش فرض</label>
                                    </div>
                                </span>
                            </div>
                            <div class="d-flex justify-content-center col-12 ">
                                <button class=" btn btn-success col-md-3 col-6" @click="submit()">
                                    ثبت
                                </button>
                            </div>
                        </div>

                    </div>
                </div>

                <div v-if="editRow">
                    <div>
                        <h4 class="mt-3" @click="changeState(0)">
                            <i class="fas fa-times text-danger"></i>
                        </h4>
                        <div class="row" id="addJobs">
                            <div class="col-12 col-md-4 text-right mt-3 mb-3">
                                <small id="LblJobCode"> کد شغل</small>
                                <input class="form-control text-left required" type="text"
                                    @keypress="$ValidNumber($event, 10)" id="JobCode" v-model="DataAxiosEdit.JobCode" />
                            </div>
                            <div class="col-12 col-md-4 text-right mt-3 mb-3">
                                <small id="LblJobName"> نام شغل</small>
                                <input class="form-control text-right required" type="text" id="JobName"
                                    v-model="DataAxiosEdit.JobName" />
                            </div>
                            <div class="col-12 col-md-3 text-right mt-3 mb-3">
                                <small id="LblPishFarz">پیش فرض</small>
                                <span class="form-control p-1">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input InputText"
                                            @click="statusChk($event)" :checked="DataAxiosEdit.PishFarz"
                                            v-model="DataAxiosEdit.PishFarz" id="DefaultHoze" />
                                        <label class="custom-control-label" for="DefaultHoze">پیش فرض</label>
                                    </div>
                                </span>
                            </div>
                            <div class="d-flex justify-content-center col-12 ">
                                <button class=" btn btn-info col-md-3 col-6" @click="editItem()">
                                    ویرایش
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </template>
        </card>
        <Modal :InheritanceTheme="true" :IsFooter="false" :Size="'Sm'" v-if="$store.state.Modal">
            <template v-slot:body>
                <div class="container p-4 modal-font">
                    <div class="mx-1 fs-1">

                        <div>
                            <label class="ml-1">
                                کد رهگیری :
                            </label>
                            <span class="ml-1">{{ detailModel.Id }}</span>
                        </div>

                        <div>
                            <label class="ml-1">
                                تاریخ ایجاد :
                            </label>
                            <span class="ml-1">{{ detailModel.ZamanInsert }}</span>

                        </div>

                        <div>
                            <label class="ml-1">
                                ایجاد کننده :
                            </label>
                            <span class="ml-1">{{ detailModel.TblUserGrpIdInsert }}</span>

                        </div>

                        <div>
                            <label class="ml-1">
                                زمان آخرین تغییرات :
                            </label>
                            <span class="ml-1">{{ detailModel.ZamanLastEdit }}</span>

                        </div>

                        <div>
                            <label class="ml-1">
                                تغییر دهنده :
                            </label>
                            <span class="ml-1">{{ detailModel.TblUserGrpIdLastEdit }}</span>

                        </div>


                    </div>
                </div>

            </template>
        </Modal>
    </div>
</template>


<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Modal from '@/pages/Modal/Modal.vue'
export default {
    components: { Card, BnpGrid, SearchableCombo, Modal },
    data() {
        return {
            propsRows: [],
            propsColumn: [],
            render: false,
            shobeId: this.$session.get("UserInfo").tblShobeId,
            showRow: true,
            addRow: false,
            editRow: false,
            DataAxios: {},
            DataAxiosEdit: {},
            detailModel: {}
        }
    },
    beforeMount() {
        this.getPropsCols()
        this.getPropsRows()
        this.$store.state.Modal = false
    },
    methods: {
        editItem() {
            if (!this.$ValidForm('addJobs')) {
                return
            }
            this.DataAxiosEdit.TblShobeId = this.shobeId
            this.DataAxiosEdit.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
            let DataAxois = {
                Action: 'Jobs',
                Method: 'put',
                ArryfildValue: this.DataAxiosEdit
            }
            this.$PostData(DataAxois).then((res) => {
                if (res.status == "Ok") {
                    this.$mySweetDefaultTost('عملیات موفق', 'آیتم با موفقیت ویرایش شد', 'success', 2000)
                    this.getPropsRows()
                    this.changeState(0)
                    this.$nextTick(() => {
                        this.render = true
                    })
                    this.DataAxiosEdit = {}
                } else {
                    this.$mySweetDefaultTost('عملیات ناموفق', res.msg, 'error', 5000)
                }

            }).catch((err) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                console.error(err)
            })
        },
        detial(item) {
            this.detailModel = item
            this.$store.state.Modal = true
        },
        submit() {
            if (!this.$ValidForm('addJobs')) {
                return
            }
            this.DataAxios.TblShobeId = this.shobeId
            this.DataAxios.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
            let DataAxois = {
                Action: 'Jobs',
                Method: 'post',
                ArryfildValue: this.DataAxios
            }
            this.$PostData(DataAxois).then((res) => {
                if (res.status == "Ok") {
                    this.$mySweetDefaultTost('عملیات موفق', 'آیتم با موفقیت افزوده شد', 'success', 2000)
                    this.getPropsRows()
                    this.changeState(0)
                    this.$nextTick(() => {
                        this.render = true
                    })
                    this.DataAxios = {}
                } else {
                    this.$mySweetDefaultTost('عملیات ناموفق', res.msg, 'error', 5000)
                }

            }).catch((err) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                console.error(err)
            })

        },
        edit(item) {
            this.DataAxiosEdit = item
            this.changeState(2)
        },
        changeState(state) {
            if (state == 0) { this.showRow = true; this.addRow = false; this.editRow = false; }
            if (state == 1) { this.showRow = false; this.addRow = true; this.editRow = false; }
            if (state == 2) { this.showRow = false; this.addRow = false; this.editRow = true; }
        },

        remove(item) {
            const swalWithBootstrapButtons = this.$swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-success mx-1',
                    cancelButton: 'btn btn-danger',
                },
                buttonsStyling: false,
            })
            swalWithBootstrapButtons
                .fire({
                    title: 'اطمینان دارید؟',
                    text: 'از حذف ' + '؟',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'بله، حذف شود',
                    cancelButtonText: 'لغو',
                    reverseButtons: true,
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        var DataaxiosDepUser = {
                            Action: 'Jobs/' + item.Id,
                            Method: 'Delete',
                            ArryfildValue: {}
                        }
                        this.$PostData(DataaxiosDepUser)
                            .then((response) => {
                                if (response.status == 'Ok') {
                                    this.getPropsRows()
                                    this.$toasted.success("حذف با موفقیت صورت گرفت", {
                                        action: {
                                            text: "بستن",
                                            onClick: (e, toastObject) => {
                                                toastObject.goAway(0);
                                            },
                                        },
                                    });
                                } else {
                                    swalWithBootstrapButtons.fire('', 'عملیات با خطا مواجه شد', 'error')
                                }
                            })
                            .catch((error) => {
                                console.error('CATCH', error)
                                swalWithBootstrapButtons.fire('', 'عملیات با خطا مواجه شد', 'error')
                            })
                    }
                })

        },
        getbankId(data) {
            if (data.id != null) {
                this.DataAxios.TblSarfaslIdBankTarafHesab = data.id
            }
        },

        getbankIdForEdit(data) {
            if (data.id != null) {
                this.DataAxiosEdit.TblSarfaslIdBankTarafHesab = data.id
            }
        },

        getPropsRows() {
            let DataAxois = {
                Action: 'Jobs',
                Method: 'get',
                ArryfildValue: {}
            }
            this.$PostData(DataAxois).then((res) => {
                this.propsRows = res
                this.render = false
                this.$nextTick(() => {
                    this.render = true
                })
            }).catch((err) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                console.error(err)
            })
        },


        getPropsCols() {
            let DataAxoisCol = {
                ArryfildValue: {
                    SoftwareId: 2,
                    UserId: 1,
                    FormName: 'frmJobs',
                    ShowView: 0,
                },
                Method: 'post',
                Action: 'ReadGridColumns',
            }
            this.$GetColumns(DataAxoisCol, true)
                .then((data) => {
                    this.propsColumn = data
                })
                .finally(() => {
                    this.$store.state.renderComponentGrid = false
                    this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true
                    })
                })
        }
    }
}
</script>
<style scoped>
.modal-font {
    font-size: 18px;
}
.modal-font span {
    font-weight: bold;
}
</style>